import { API_GRAPHQL } from "../../constants";
// import { API_BASE_URL } from "../../constants";
import { useState, useEffect } from "react";
import { getLocalStorageItem } from "../../helpers/storage";

// export function useRetrieveOrderedProducts() {
//     const url = `${API_BASE_URL}/ordered-products`;
//     const [products, setProducts] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [isError, setIsError] = useState(false);

//     useEffect(() => {
//         async function getProducts(url) {
//             try {
//                 setIsLoading(true);
//                 setIsError(false);

//                 const response = await fetch(url);
//                 const products = await response.json();
//                 console.log(products);
//                 setProducts(products.data);
//             } catch(error) {
//                 console.log(error);
//                 setIsError(true);
//             } finally {
//                 setIsLoading(false);
//             }
//         }

//         getProducts(url);
//     }, [url]);
//     return { products, isLoading, isError};
// }

// export default useRetrieveOrderedProducts;


//   export function useRetrieveOrderedProductsGraphQL() {
//     const url = `${API_GRAPHQL}`;
//     const [products, setProducts] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [ isError, setIsError] = useState(false);

//     useEffect(() => {
//         async function getProducts(url) {
//             try {
//                 setIsLoading(true);
//                 setIsError(false);

//                 const response = await fetch(url, {
//                     method: 'POST',
//                     headers: {'Content-Type': 'application/json' },
//                     body: JSON.stringify(
//                         {query: `{
//                             orderedProducts{
//                               data{
//                                 attributes{
//                                   product{
//                                     data{
//                                       attributes{
//                                         name
//                                         image{
//                                             data{
//                                                 attributes{
//                                                     url
//                                                 }
//                                             }
//                                         }
//                                           category{
//                                           data{
//                                             attributes{
//                                               place
//                                             }
//                                             id
//                                           }
//                                         }
//                                       }
//                                     }
//                                   }
//                                 }
//                               }
//                             }
//                           }`
//                     })
//                 });
//                 const products = await response.json();
//                 console.log(products);
//                 setProducts(products.data.orderedProducts.data);
//             } catch(error) {
//                 console.log(error);
//                 setIsError(true);
//             } finally {
//                 setIsLoading(false);
//             }
//         }

//         getProducts(url);
//     }, [url]);
//     return {products, isLoading, isError}
// }

// export default useRetrieveOrderedProductsGraphQL;

// export function useRetrieveOrderedProductsGraphQL() {
//     const url = `${API_GRAPHQL}`;
//     const [products, setProducts] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [ isError, setIsError] = useState(false);
//     const info = getLocalStorageItem('user');
//     const id = info.user.id;
//     console.log(id);

//     useEffect(() => {
//         async function getProducts(url) {
//             try {
//                 setIsLoading(true);
//                 setIsError(false);

//                 const response = await fetch(url, {
//                     method: 'POST',
//                     headers: {'Content-Type': 'application/json' },
//                     body: JSON.stringify(
//                         {query: `{
//                             orderedProducts(filters: {customer: {id:{eq:${id}}}){
//                                 data{
//                                   attributes{
//                                     serial_number
//                                     product{
//                                       data{
//                                         attributes{
//                                           name
//                                         }
//                                       }
//                                     }
//                                   }
//                                 }
//                               }
//                           }`
//                     })
//                 });
//                 const products = await response.json();
//                 console.log(products);
//                 // setProducts(products.data.orderedProducts.data);
//             } catch(error) {
//                 console.log(error);
//                 setIsError(true);
//             } finally {
//                 setIsLoading(false);
//             }
//         }

//         getProducts(url);
//     }, [url]);
//     return {products, isLoading, isError}
// }

// export default useRetrieveOrderedProductsGraphQL;


export function useRetrieveOrderedProductsGraphQLTest() {
  const url = `${API_GRAPHQL}`;
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const info = getLocalStorageItem('user');
  const id = info.user.id;

  useEffect(() => {
      async function getProducts(url) {
          try {
              setIsLoading(true);
              setIsError(false);

              const response = await fetch(url, {
                  method: 'POST',
                  headers: {'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    query:`{
                      orderedProducts(
                        pagination: {limit: 100},
                        filters: {customer: {id:{eq:${1}}}}) {
                        data{
                          attributes{
                            serial_number
                            product{
                              data{
                                id
                                attributes{
                                  name
                                  image{
                                    data{
                                      attributes{
                                        url
                                      }
                                    }
                                  }
                                  supplier{
                                    data{
                                      attributes{
                                        name
                                      }
                                    }
                                  }
                                  category{
                                    data{
                                      id
                                      attributes{
                                        place
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }`
                  })
              });

              const result = await response.json();
              setProducts(result.data.orderedProducts.data);
          } catch(error) {
              console.error(error);
              setIsError(true);
          } finally {
              setIsLoading(false);
          }
      }

      getProducts(url);
  }, [url, id]);

  return {products, isLoading, isError};
}

export default useRetrieveOrderedProductsGraphQLTest;